import dayjs from 'dayjs';

function validateDate(
  date,
  format = 'MM/DD/YYYY',
  message = 'Date is not valid.',
) {
  return isValidDate(date, format) ? true : message;
}

function isValidDate(date, format = 'MM/DD/YYYY') {
  return dayjs(date, format, true).isValid();
}

export const commonValidators = {
  date: (date) => validateDate(date),
};

type Validation = {
  validateFutureDate?: (value: string) => string | boolean;
  validatePastDate?: (value: string) => string | boolean;
  isLessThanMaxDate?: (value: string) => string | boolean;
  isGreaterThanMinDate?: (value: string) => string | boolean;
};
export function buildDateValidation(dateRules) {
  const { allowFutureDate = true, allowPastDate = true } = dateRules;
  const validation: Validation = {};
  if (!allowFutureDate) {
    validation.validateFutureDate = (value) => {
      const today = new Date();
      const result =
        new Date(value) <= today
          ? true
          : `Date entered cannot be after current date of ${today.toLocaleDateString()}`;

      return result;
    };
  }
  if (!allowPastDate) {
    validation.validatePastDate = (value) => {
      const today = new Date();
      const result =
        new Date(value) >= today
          ? true
          : `Date entered cannot be before current date of ${today.toLocaleDateString()}`;

      return result;
    };
  }

  return { ...validation };
}
